export { ChampionStage, CHAMPION_STAGE_SIZE } from "./ChampionStage"
export type { ChampionStageProps } from "./ChampionStage"
